/* Behaviour limited to the new PDP template; native Shopify cart and variant logic remain authoritative. */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('product-info[data-rn-shared-pdp="true"]');
  if (!root) return;
  const sticky = document.querySelector('sticky-atc-bar-minimalist');
  const footer = document.querySelector('footer, .shopify-section-group-footer-group');
  const bar = sticky;
  let footerVisible = false;
  if (bar && footer && 'IntersectionObserver' in window) {
    // The bar shows only while Add to basket has scrolled off the top, and steps back for the footer, basket drawer and keyboard.
    const hideForOverlay = () => { const drawer = document.querySelector('cart-drawer[open], .cart-drawer.is-open, .drawer[open]'); const keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * .72; const rect = document.getElementById(bar.dataset.rnFormId)?.querySelector('[type="submit"][name="add"]')?.getBoundingClientRect(); bar.classList.toggle('sticky-atc-bar--show', Boolean(rect && rect.height && rect.bottom <= 0 && !footerVisible && !drawer && !keyboard)); };
    new IntersectionObserver(entries => { footerVisible = entries.some(entry => entry.isIntersecting); hideForOverlay(); }).observe(footer);
    window.addEventListener('scroll', hideForOverlay, {passive:true});
    window.visualViewport?.addEventListener('resize', hideForOverlay);
  }
  root.querySelectorAll('img').forEach(img => img.addEventListener('error', () => { const stage = img.closest('.product__media-item-container'); if (stage && !stage.querySelector('.rn-pdp__image-error')) { const message=document.createElement('span'); message.className='rn-pdp__image-error'; message.textContent='Image unavailable'; stage.append(message); } }));
  const fieldset = root.querySelector('.rn-field--photos');
  if (fieldset) {
    const first = fieldset.querySelector('[data-rn-photo-index="1"]');
    const add = fieldset.querySelector('[data-rn-add-photo]');
    const slots = fieldset.querySelector('[data-rn-photo-slots]');
    const templates = Array.from(fieldset.querySelectorAll('[data-rn-photo-template]'));
    const shown = new Set();
    const syncAdd = () => { if (add) add.hidden = !first?.files?.length || shown.size >= templates.length; };
    first?.addEventListener('change', syncAdd);
    syncAdd();
    add?.addEventListener('click', () => {
      if (!first?.files?.length || shown.size >= templates.length) return;
      const template = templates.find(t => !shown.has(t.dataset.rnPhotoTemplate));
      shown.add(template.dataset.rnPhotoTemplate);
      const row = template.content.cloneNode(true);
      slots.append(row);
      slots.lastElementChild?.querySelector('input')?.focus();
      syncAdd();
    });
    fieldset.addEventListener('change', event => {
      const input=event.target;
      if (!input.matches('[data-rn-photo]')) return;
      const upload=input.closest('.rn-upload');
      const name=upload?.querySelector('[data-rn-upload-name]');
      const status=upload?.querySelector('[data-rn-upload-status]');
      const title=upload?.querySelector('.rn-upload__title');
      const file=input.files?.[0];
      if (title) { title.dataset.defaultText ||= title.textContent; title.textContent=file ? 'Replace' : title.dataset.defaultText; }
      if (name) name.textContent=file?.name || '';
      if (status) status.textContent=file ? 'Selected' : '';
      if (file && input.dataset.rnPhotoIndex !== '1') {
        const preview=upload?.querySelector('[data-rn-upload-preview]');
        const img=upload?.querySelector('[data-rn-upload-image]');
        if (preview) preview.hidden=false;
        if (img) { img.src=URL.createObjectURL(file); img.alt=`Preview of ${file.name}`; img.hidden=false; }
      }
    });
    fieldset.addEventListener('click', event => {
      const remove=event.target.closest('[data-rn-remove-photo]');
      if (!remove) return;
      const row=remove.closest('.rn-pdp__photo-row');
      const input=row?.querySelector('input[type="file"]') || (remove.dataset.rnRemoveMain ? first : null);
      if (input) { input.value=''; input.dispatchEvent(new Event('change',{bubbles:true})); }
      if (row) { shown.delete(input?.dataset.rnPhotoIndex); row.remove(); }
      syncAdd();
      add?.focus();
    });
  }
  const gallery = root.querySelector('.product__media-gallery');
  if (gallery) { const thumbs = gallery.querySelectorAll('.thumbnail-list > *'); thumbs.forEach((thumb,i) => thumb.setAttribute('aria-label', `Image ${i+1} of ${thumbs.length}`)); }
});
